module.exports = __webpack_public_path__ + "static/media/chendhur_logo_icon_nobg.5b82c2e7.png";